import { render, staticRenderFns } from "./Fruehstueckauswahl.vue?vue&type=template&id=2a10aadf&scoped=true"
import script from "./Fruehstueckauswahl.vue?vue&type=script&lang=js"
export * from "./Fruehstueckauswahl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10aadf",
  null
  
)

export default component.exports